/**
 * SchemaDropdown
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Workspaces
import { makeSelectQueryStringValue } from '../../../../workspaces/react-router-selectors';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    clearPageOnChange?: boolean;
    updateQueryString: Function;
    schemas?: string | string[];
    options: {
        key: number,
        text: string,
        value: number
    }[];
    multiple: boolean;
}

export class SchemaDropdown extends React.Component<Props> {
    handleChange = (
        event: SyntheticInputEvent<EventTarget>,
        data: { value: number }
    ) => {
        const { clearPageOnChange } = this.props;
        this.props.updateQueryString({
            ...(clearPageOnChange ? { page: undefined } : {}),
            schemas: data.value,
            selectedEvent: undefined
        });
    };

    render() {
        const { schemas, options, multiple } = this.props;
        return (
            <Dropdown
                placeholder="All Jobs"
                search
                selection
                value={schemas || null}
                clearable
                selectOnBlur={false}
                options={options}
                onChange={this.handleChange}
                lazyLoad
                multiple={multiple}
                closeOnChange
                fluid
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    schemas: makeSelectQueryStringValue('schemas'),
    options: selectOptions
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(SchemaDropdown);
